import { RuleGuestAttributeResourceTypeRelation, RuleResourceTypeBetween } from "../../../shared/types";
import { RelationRuleValidator } from "./types";

export const relationBetween: RelationRuleValidator<RuleResourceTypeBetween<RuleGuestAttributeResourceTypeRelation>> = {
	validate: (rule, value) => {
		if (value == null || rule.value == null) {
			return false;
		}

		switch (rule.guestAttribute.entityType) {
			case "hotelStay.checkIn":
			case "hotelStay.checkOut": {
				const dates = ((Array.isArray(value) ? value : [value]) as string[]).filter((date) => !!date);
				const { start, end } = rule.value;
				return dates.some((date) => date >= start && date <= end);
			}
			default:
				throw new Error("Not implemented rule");
		}
	},
};
